import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { IconPin, IconPinned } from '../../../base/icons/svg';
import ContextMenuItem from '../../../base/ui/components/web/ContextMenuItem';
import { COMMANDS } from '../../../mod-command/constants';
import { getModCommand } from '../../../mod-command/functions';
import { NOTIFY_CLICK_MODE } from '../../../toolbox/types';
import { openDialog } from '../../../base/dialog/actions';
import ConfirmPinAllDialog from './ConfirmPinAllDialog';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(() => {
    return {
        contextMenuItem: {}
    };
});
const TogglePinToAllButton = ({ className, noIcon = false, notifyClick, notifyMode, onClick, participantID }) => {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isPinnedAll = useSelector((state) => !!getModCommand(state, COMMANDS.PIN_PARTICIPANT.COMMAND));
    const valueCommand = useSelector((state) => getModCommand(state, COMMANDS.PIN_PARTICIPANT.COMMAND));
    const handlePinnedParticipant = useCallback(() => {
        notifyClick?.();
        if (notifyMode === NOTIFY_CLICK_MODE.PREVENT_AND_NOTIFY) {
            return;
        }
        dispatch(openDialog(ConfirmPinAllDialog, { participantID }));
        // if(isPinnedAll){
        //     dispatch(sendCommand(COMMANDS.UN_PIN_PARTICIPANT.COMMAND, participantID, true))
        // }else{
        //     dispatch(sendCommand(COMMANDS.PIN_PARTICIPANT.COMMAND, participantID, true))
        // }
        onClick?.();
    }, [dispatch, notifyClick, onClick, participantID, isPinnedAll]);
    const text = isPinnedAll && (valueCommand?.value === participantID)
        ? t('videothumbnail.unpinFromAll')
        : t('videothumbnail.pinToAll');
    const icon = isPinnedAll ? IconPinned : IconPin;
    return (React.createElement(ContextMenuItem, { participantID: participantID, accessibilityLabel: text, icon: noIcon ? null : icon, onClick: handlePinnedParticipant, text: text, textClassName: className, iconClassName: classes.contextMenuItem }));
};
export default TogglePinToAllButton;
